<template>
  <div>
    <v-card class="cardWrap">
      <CardTitle title="マスタ管理" />
      <v-tabs
          background-color="white accent-4"
          color="black"
        >
        <v-tab @click="seen = 'Template'">定型文</v-tab>
        <v-tab :class="{ 'd-none': golfUser }" @click="seen = 'GolfGroup'">ゴルフグループ</v-tab>
        <v-tab :class="{ 'd-none': golfUser }" @click="seen = 'GolfCourse'">ゴルフ場</v-tab>
        <v-tab @click="seen = 'PointClass'">ポイント区分</v-tab>
        <v-tab @click="seen = 'WithdrawalReason'">退会理由</v-tab>
        <v-tab @click="seen = 'Holiday'">祝日設定</v-tab>
        <v-tab :class="{ 'd-none': golfUser }" @click="seen = 'Authority'">権限設定</v-tab>
      </v-tabs>
      <keep-alive>
        <component :is="seen" />
      </keep-alive>
    </v-card>
  </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import GolfGroup from './page/GolfGroup';
import GolfCourse from './page/GolfCourse';
import PointClass from './page/PointClass';
import WithdrawalReason from './page/WithdrawalReason';
import Template from './page/Template';
import Holiday from './page/Holiday';
import Authority from './page/Authority';
import { authorityMixin } from '@/views/authorityMixin';

export default {
    mixins: [
        authorityMixin
    ],
    components: {
        CardTitle,
        GolfGroup,
        GolfCourse,
        PointClass,
        WithdrawalReason,
        Template,
        Holiday,
        Authority
    },
    async created () {
        this.admin = await this.getLoginAdmin();
    },
    computed: {
        golfUser () {
            return this.admin.user_div !== 1;
        }
    },
    data () {
        return {
            seen: 'Template',
            admin: {
                user_div: null
            }
        };
    },
    methods: {
        /** --------------------------------------------
     * ゴルフグループ情報を取得
     * -------------------------------------------- */
        clickPagination: function () {
            this.begin_row = this.page * 10 - 10;
            this.getMember();
        },
        clickSearch: function () {
            this.page = 1;
            this.begin_row = 0;
            this.getMember();
        }
    }
};
</script>

<style>

</style>
